import { useEffect, useRef, useState } from 'react'

/** Email search + chips — focus the whole board on up to `max` clients. */
export function ClientFilter({
  clients,
  selected,
  onChange,
  max = 5,
}: {
  clients: string[]
  selected: string[]
  onChange: (s: string[]) => void
  max?: number
}) {
  const [q, setQ] = useState('')
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!open) return
    const h = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false)
    }
    document.addEventListener('mousedown', h)
    return () => document.removeEventListener('mousedown', h)
  }, [open])

  const full = selected.length >= max
  const matches =
    open && q.trim()
      ? clients.filter((c) => c.toLowerCase().includes(q.trim().toLowerCase()) && !selected.includes(c)).slice(0, 8)
      : []
  const add = (c: string) => {
    if (!full) {
      onChange([...selected, c])
      setQ('')
    }
  }

  return (
    <div ref={ref} className="relative min-w-[230px]">
      <div className="flex flex-wrap items-center gap-1 rounded-lg border border-stone-200 bg-white px-2 py-1 dark:border-stone-700 dark:bg-stone-900">
        {selected.map((c) => (
          <span key={c} className="inline-flex max-w-full items-center gap-1 rounded-md bg-champagne-100 px-1.5 py-0.5 text-[11px] text-champagne-900 dark:bg-champagne-500/20 dark:text-champagne-200">
            <span className="max-w-[150px] truncate">{c}</span>
            <button onClick={() => onChange(selected.filter((x) => x !== c))} className="shrink-0 text-champagne-700 hover:text-champagne-950 dark:text-champagne-300" aria-label={`Remove ${c}`}>
              ×
            </button>
          </span>
        ))}
        {!full && (
          <input
            value={q}
            onChange={(e) => {
              setQ(e.target.value)
              setOpen(true)
            }}
            onFocus={() => setOpen(true)}
            placeholder={selected.length ? 'Add…' : 'Filter by client email…'}
            className="min-w-[130px] flex-1 bg-transparent py-0.5 text-sm outline-none placeholder:text-stone-400 dark:placeholder:text-stone-500"
          />
        )}
      </div>
      {matches.length > 0 && (
        <div className="absolute left-0 right-0 z-30 mt-1 max-h-60 overflow-auto rounded-lg border border-stone-200 bg-white py-1 shadow-lg dark:border-stone-700 dark:bg-stone-900">
          {matches.map((c) => (
            <button
              key={c}
              onClick={() => add(c)}
              className="block w-full truncate px-3 py-1.5 text-left text-sm text-stone-700 hover:bg-stone-100 dark:text-stone-200 dark:hover:bg-stone-800"
            >
              {c}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
